import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Typography } from "@mui/material";
import { BooleanInput, Edit, SimpleForm, TextField, TextInput } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { ListTenant } from "./ListTenant";
var TenantForm = function () {
    return (_jsxs(SimpleForm, { children: [_jsx(Typography, { variant: "h4", children: "Customer" }), _jsx(Typography, { variant: "body2", children: "Customer configuration" }), _jsx(Typography, { variant: "h5", children: "ID" }), _jsx(TextField, { source: "id" }), _jsx(TextInput, { source: "slug" }), _jsx(BooleanInput, { source: "is_active" }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                    name: null,
                    collapsed: true,
                    enableClipboard: true,
                    displayDataTypes: false,
                } })] }));
};
export var EditTenant = function () {
    return (_jsx(ListTenant, { aside: _jsx(Edit, { sx: { flexGrow: 2, width: "50%" }, children: _jsx(TenantForm, {}) }) }));
};
